import {
  Component,
  Input,
  Output,
  EventEmitter,
  IterableDiffers,
  DoCheck,
  IterableDiffer,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { TreeNode, TreeNodeOperation } from './tree.types';

@Component({
  selector: 'wfm-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements DoCheck, OnChanges {
  @Input() nodes: TreeNode[];

  @Input() operations: TreeNodeOperation[];

  @Input() showIcons = false;

  @Input() alignAfterCaret = false;

  @Input() selectedNode: TreeNode;

  @Input() pinnedIcon = false;

  @Input() dropdownOperations = false;

  @Input() findingsEnabled = false;

  @Output() selectedNodeChange = new EventEmitter<TreeNode>();

  @Output() nodeOpen = new EventEmitter<TreeNode>();

  @Output() nodeClose = new EventEmitter<TreeNode>();

  @Output() performOperation = new EventEmitter<{ node: TreeNode; operation: TreeNodeOperation }>();

  @Output() selectPin = new EventEmitter<{ node: TreeNode }>();

  sublevels = false;
  private differ: IterableDiffer<any>;

  constructor(private differs: IterableDiffers) {
    this.differ = this.differs.find([]).create(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.nodes) {
      this.setSublevelFlag();
    }
  }

  ngDoCheck(): void {
    if (this.differ.diff(this.nodes)) {
      this.setSublevelFlag();
    }
  }

  select(node: TreeNode) {
    if (!this.clickEnabled) {
      this.clickEnabled = true;
      return;
    }

    this.selectedNode = node;
    node.isOpen = true && node.children && node.children.length > 0;
    this.selectedNodeChange.emit(node);
  }

  private clickEnabled = true;
  open(node: TreeNode) {
    node.isOpen = true;
    this.clickEnabled = false;
    this.nodeOpen.emit(node);
  }

  close(node: TreeNode) {
    node.isOpen = false;
    this.clickEnabled = false;
    this.nodeClose.emit(node);
  }

  perform(operation: TreeNodeOperation, node: TreeNode, event?) {
    event?.stopPropagation();
    if (this.dropdownOperations) {
      node.isDropdownOpen = false;
    }
    this.clickEnabled = false;
    this.performOperation.emit({ node, operation });
  }

  pinSavedWorkList(node: TreeNode) {
    this.clickEnabled = false;
    node.isPinned = !node.isPinned;
    this.selectPin.emit({ node });
  }

  pinChild(event: { node: TreeNode }) {
    this.selectPin.emit(event);
  }

  selectChild(node: TreeNode) {
    this.selectedNode = node;
    this.selectedNodeChange.emit(node);
  }

  openChild(node: TreeNode) {
    this.nodeOpen.emit(node);
  }

  closeChild(node: TreeNode) {
    this.nodeClose.emit(node);
  }

  performOperationChild(event: { node: TreeNode; operation: TreeNodeOperation }) {
    this.performOperation.emit(event);
  }

  private setSublevelFlag() {
    this.sublevels = !!this.nodes && !!this.nodes.find(n => n && n.children && n.children.length > 0);
  }
}
